var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDash4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 17,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9 33.2L30.8 29.1C31.2 28.1 31 26.8 30.1 26C29.2 25.1 27.9 24.9 26.8 25.4L28.7 27.3L27.3 28.7L25.3 26.7C24.8 27.8 25 29.1 25.9 30.1C26.8 31 28 31.2 29 30.8L33.1 34.9C33.3 35.1 33.6 35.1 33.7 34.9L34.7 33.9C35 33.6 35 33.3 34.9 33.2ZM25 32H14V30C14 27.8 17.6 26 22 26C22.5 26 23 26 23.4 26.1C23.1 26.7 23 27.3 23 28C23 29.6 23.8 31.1 25 32ZM22 16C19.8 16 18 17.8 18 20C18 22.2 19.8 24 22 24C24.2 24 26 22.2 26 20C26 17.8 24.2 16 22 16Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDash4);
export default __webpack_public_path__ + "static/media/Dash4.dfd9054f401a630dee3ad5b478abb53b.svg";
export { ForwardRef as ReactComponent };